import {createDropdown, createInputField, disableFormControls} from '../forms/formFields';

const createJsonConverterTaskForm = ({task = {}, taskErrors = {}, editable = true,
                                        mxResources, onChange = () => {}} = {}) => {
    let current = task.sourceExpression;
    let currentSourceType = task.sourceType;
    let destroyed = false;
    const element = document.createElement('div');
    element.id = 'jsonConverterEditor';
    element.className = 'ui form';
    const sourceTypeHelpKeys = new Map([
        ['JSON', 'jsonConverterSourceTypeJSONHelp'], ['YAML', 'jsonConverterSourceTypeYAMLHelp'],
        ['XML', 'jsonConverterSourceTypeXMLHelp'], ['CSV', 'jsonConverterSourceTypeCSVHelp']
    ]);
    const sourceTypeField = createDropdown({label: mxResources.get('jsonConverterSourceType'),
        id: 'jsonConverterSourceType', name: 'sourceType', className: 'required',
        value: currentSourceType ?? '', error: taskErrors?.fields?.sourceType, help: ' ',
        options: [{value: '', name: mxResources.get('jsonConverterSourceTypePlaceholder')},
            ...Array.from(sourceTypeHelpKeys.keys(), value => ({value, name: value}))]});
    const sourceType = sourceTypeField.querySelector('select');
    const sourceTypeHelp = sourceTypeField.children[sourceTypeField.children.length - 1];
    sourceTypeHelp.id = 'jsonConverterSourceTypeHelp';
    element.appendChild(sourceTypeField);
    const field = createInputField({label: mxResources.get('jsonConverterSourceExpression'),
        id: 'jsonConverterSourceExpression', name: 'sourceExpression', type: 'text', className: 'required',
        placeHolder: mxResources.get('expressionPlaceholder'), value: current ?? '',
        error: taskErrors?.fields?.sourceExpression});
    const input = field.querySelector('input');
    const updateSourceTypeHelp = () => {
        const helpKey = sourceTypeHelpKeys.get(sourceType.value);
        sourceTypeHelp.textContent = helpKey ? mxResources.get(helpKey) : '';
        sourceTypeHelp.style.display = helpKey ? '' : 'none';
    };
    const sync = () => {
        if (destroyed) return;
        updateSourceTypeHelp();
        if (editable) {
            const patch = {};
            if (input.value !== (current ?? '')) {
                current = input.value;
                patch.sourceExpression = current;
            }
            if (sourceType.value !== (currentSourceType ?? '')) {
                currentSourceType = sourceType.value || null;
                patch.sourceType = currentSourceType;
            }
            if (Object.keys(patch).length) onChange(patch);
        }
    };
    updateSourceTypeHelp();
    input.addEventListener('change', sync);
    sourceType.addEventListener('change', sync);
    element.appendChild(field);
    const help = document.createElement('details');
    const summary = document.createElement('summary');
    summary.textContent = mxResources.get('jsonConverterHelpTitle');
    help.appendChild(summary);
    ['jsonConverterPurposeHelp', 'jsonConverterSourceHelp', 'jsonConverterOutputHelp',
        'jsonConverterLimitsHelp', 'jsonConverterRecoveryHelp'].forEach(key => {
        const paragraph = document.createElement('p');
        paragraph.textContent = mxResources.get(key);
        help.appendChild(paragraph);
    });
    element.appendChild(help);
    if (!editable) {
        disableFormControls(element);
    }
    return {
        element,
        getTask: () => ({...(typeof current === 'undefined' ? {} : {sourceExpression: current}),
            ...(typeof currentSourceType === 'undefined' ? {} : {sourceType: currentSourceType})}),
        sync,
        appendJsonExpressionHelp(helpText) {
            if (!destroyed && helpText && !element.querySelector('#jsonConverterExpressionHelp')) {
                const wrapper = document.createElement('div');
                wrapper.id = 'jsonConverterExpressionHelp';
                wrapper.insertAdjacentHTML('beforeend', helpText);
                element.appendChild(wrapper);
            }
        },
        destroy() {
            sync();
            destroyed = true;
        }
    };
};

export {createJsonConverterTaskForm};
